export const hasPermission = (permissions, moduleName, action = "view") => {
  const modulePermission = permissions.find(
    (p) => p.module === moduleName && p.enabled
  );
  return modulePermission ? modulePermission[action] === true : false;
};
